import { IAppState } from '../../common/state';

export function selectBannerTypeRotation(state: IAppState): number | null {
  return state.bannerTypeRotation;
}
